const Dashboard = {
    dashboard: () => "store/staff/dashboard",
}

export default Dashboard
